var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.systemInfo.THEME.login == '教学')?_c('Jiaoxue'):_vm._e(),(_vm.systemInfo.THEME.login == '测评')?_c('Ceping'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }